import styled from 'styled-components'
import { Button } from 'reactstrap'
import { Children } from 'react'
import { getIcon } from 'e-submission/components/Icon'

export const ButtonWithLoadingComponent = styled(Button)`
  font-weight: bold;
  min-width: 100px;
  ${(props) => (props.block ? `display: block;` : null)}
  svg,
  span {
    display: inline-block;
    vertical-align: middle;
  }
  .spinner_loading {
    width: 30px;
    height: 30px;
    content: '';
    border-radius: 50%;
    border-top: 2px solid transparent;
    border-left: 2px solid #ffffff;
    -webkit-animation: spin 0.75s linear infinite;
    animation: spin 0.75s linear infinite;
  }
  .spinner-cloneapp-overlay {
    width: 80px;
    height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .spinner-cloneapp-overlay span {
    margin-left: 8px;
  }
  .spinner-cloneapp {
    border: 6px solid #f3f3f3;
    /* Light grey border */
    border-top: 6px solid #00008f;
    /* Blue border */
    border-radius: 50%;
    width: 30px;
    height: 30px;
    animation: spin 0.75s linear infinite;
    /* Spin animation */
  }
  svg {
    height: 0.825em;
    width: 0.825em;
    margin-right: 4px;
  }
  &.btn-outline-disabled {
    pointer-events: none;
  }
`

function Component({ color = 'primary', onClick, loading, ...props }) {
  if (props.block) {
  }
  const isDisabled = props.disabled || loading
  const shouldShowLoading = loading === undefined ? props.disabled : loading
  return (
    <ButtonWithLoadingComponent
      onClick={isDisabled ? undefined : onClick}
      color={isDisabled ? 'disabled' : color}
      {...props}
      disabled={isDisabled}
    >
      {shouldShowLoading == true ? (
        <div className="spinner-cloneapp-overlay">
          <div className="spinner-cloneapp"></div>
          <span>{props.children}</span>
        </div>
      ) : props.icon ? (
        Children.toArray([getIcon(props.icon), <span className="TEE">{props.children}</span>])
      ) : (
        <span>{props.children}</span>
      )}
    </ButtonWithLoadingComponent>
  )
}

export default Component
